var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[(!!_vm.$scopedSlots.header)?_c('header',[_vm._t("header")],2):_vm._e(),_vm._v(" "),(!!_vm.$scopedSlots.main)?_c('main',[_vm._t("main")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }